import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useEffect } from 'react'


function HowItWorks() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className='text-center max-w-prose mx-auto my-24 xl:my-36 px-8'>
        <div className=' text-white my-12'>
          <p className="text-3xl font-custom  mb-8">
            How it works
          </p>
          <p className="text-sm font-sans">
          Joining Museum Circle is simple—just follow these five easy steps to become part of our community. Whether you're here to exchange insights, explore new technologies, or connect with fellow museum professionals, this guide will help you get started.<br></br><br></br>Need assistance? Our team is happy to help. Visit our <a href='/contact' className='font-custom_bold text-white hover:underline'>contact page</a> to reach out. </p>
        </div>
      </div>

      <div className='max-w-prose mx-auto my-24 xl:my-36 mb-36 xl:mb-48 px-8'>
        
        <div className=' text-white my-24 xl:my-36'>
        <img
          src={"/assets/images/banners/museumcircle_banner0.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-auto object-cover rounded-3xl my-8 "
        />
          <p className="text-3xl font-custom  mb-8">
            1 – Apply for membership
          </p>
          <p className="text-sm font-sans">
          Visit our website and complete the application form by entering your full name, profession, email address and country of residence. Be sure to provide accurate details to help us process your application smoothly. For faster approval, we recommend using your professional e-mail address (e.g., name@yourmuseum.com)
          </p>
          <Button className="my-8 w-full dark bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#4d4dff] hover:border-white" variant="outline">Become a member →</Button>
        </div>

        <div className=' text-white my-24 xl:my-36'>
        <img
          src={"/assets/images/banners/museumcircle_banner25.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-auto object-cover rounded-3xl my-8 "
        />
          <p className="text-3xl font-custom  mb-8">
            2 – Application review & confirmation
          </p>
          <p className="text-sm font-sans">
          Our team will personally review your application to ensure it aligns with our community guidelines. This process helps us maintain a meaningful and high-quality space for all members. You’ll receive an email notification once your application is approved.<br></br><br></br> If we’re unable to verify your work, we may reach out to confirm your eligibility.</p>
        </div>

        <div className=' text-white my-24 xl:my-36'>
        <img
          src={"/assets/images/banners/museumcircle_banner4.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-auto object-cover rounded-3xl my-8 "
        />
          <p className="text-3xl font-custom  mb-8">
            3 – Recieve your invitation
          </p>
          <p className="text-sm font-sans">
          Once your application is approved, you’ll receive an email with a personalised invitation link to join Museum Circle. Be sure to check your inbox (and spam folder) for your invitation, as it is your gateway to getting started.</p>
        </div>

        <div className=' text-white my-24 xl:my-36'>
        <img
          src={"/assets/images/banners/museumcircle_banner34.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-auto object-cover rounded-3xl my-8 "
        />
          <p className="text-3xl font-custom  mb-8">
            4 – Set up your account
          </p>
          <p className="text-sm font-sans">
          Follow the onboarding email with step-by-step instructions to create your profile, personalize your settings, and start engaging with the community. You can now share insights, explore discussions, and connect with fellow members.</p>
        </div>

        <div className=' text-white my-24 xl:my-36'>
        <img
          src={"/assets/images/banners/museumcircle_banner33.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-auto object-cover rounded-3xl my-8 "
        />
          <p className="text-3xl font-custom  mb-8">
            5 – Access the platform online or with the mobile app
          </p>
          <p className="text-sm font-sans">
          Museum Circle is designed to fit seamlessly into your workflow. You can access the platform anytime through your browser or on the go with the mobile app. The app makes it even easier to stay connected, join discussions, and explore new ideas wherever you are.</p>

          <div className="flex flex-col md:flex-row justify-between my-8 space-y-2 md:space-y-0 md:space-x-2">
    <Button
      asChild
      className="w-full dark bg-[#f5f5f5] font-sans text-[#4d4dff] hover:text-[#4d4dff] hover:bg-white"
      variant="secondary"
    >
      <Link to="https://online.museumcircle.org" target="_self">Sign in</Link>
    </Button>

    <Button
      asChild
      className="w-full dark bg-transparent border-2 border-white font-sans text-white hover:bg-white hover:text-[#4d4dff] hover:border-white"
      variant="outline"
    >
      <Link to="/requestaccess">Download for iOS →</Link>
    </Button>

    <Button
      asChild
      className="w-full dark bg-transparent border-2 border-white font-sans text-white hover:bg-white hover:text-[#4d4dff] hover:border-white"
      variant="outline"
    >
      <Link to="/requestaccess">Download for Android →</Link>
    </Button>
  </div>
        </div>
      </div>

    </>
  );
}

export default HowItWorks;